import { activityConstants } from '../constants/activity.constants';
import activityService from '../services/activity.service';
import { alertActions } from './alert.actions';

export const activityActions = {
  fetch,
};

function fetch(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const activity = await activityService.fetch(params);
      dispatch(success(activity));
    } catch (error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: activityConstants.FETCH_REQUEST } }
  function success(activity) { return { type: activityConstants.FETCH_SUCCESS, activity } }
  function failure(error) { return { type: activityConstants.FETCH_FAILURE, error } }
}
